import React from 'react';

import './Footer.scss';
import { ReactComponent as PowerByEnergic } from '../../assets/icons/powered-by-energic.svg';

/**
 * Footer component
 */
function Footer() {
  return (
    <div className="ev-footer">
      <PowerByEnergic />
    </div>
  );
}

export default Footer;
